<template>
  <v-layout row>
    <v-flex
      xs12
      sm10
      offset-sm1
      md8
      offset-md2
      lg6
      offset-lg3
      xl6
      offset-xl3
    >
      <v-card flat>
        <v-card-text>
          <div>
            <div class="select-outlet">
              PLEASE SELECT AREA:
            </div>
            <div
              v-for="(area, index) in areas"
              :key="index"
              class="outlets mt-4 mb-3"
              @click="selectArea(area)"
            >
              <div>
                <h3
                >{{ area.name }}</h3>
                <img
                  :src="myPhoto(area.id)"
                  style="width: 100%; height: 130px;"
                  @error="imageLoadError"
                />
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'areas',
  layout: 'group',
  metaInfo () {
    return { title: 'Areas' }
  },
  computed: {
    ...mapGetters('area', [
      'areas',
    ]),
  },
  methods:{
    async selectArea(area) {
      await this.$store.dispatch('setSelectedArea', area.id)
      this.$router.push({ name: 'area1', params: { id: area.id } })
    },
    myPhoto(areaID) {
      return 'https://gemscms.aptsys.com.sg/gems_images/IOrderGroup/' + areaID + '/banner.png'
    },
    imageLoadError(event) {
      event.target.src = window.config.sharedPictures + 'sample_bg.jpg'
    }
  }
}
</script>

<style scoped>
  .select-outlet {
    font-size: 17px;
    text-transform: uppercase;
  }
</style>



// WEBPACK FOOTER //
// src/pages/areas.vue